//-----------------
// is alphanumeric
//-----------------
export default function isAlphanumeric(e) {
  let regex = null;
  //-----------------------
  // allow delete/bsp keys
  //-----------------------
  if (e.key === "Delete" || e.key === "Backspace") {
    return true;
  }
  //----------------------
  // prevent command keys
  //----------------------
  if (e.shiftKey || e.ctrlKey || e.option || e.altKey) {
    return false;
  }
  //-------------------------------
  // only accept a-z on first char
  //-------------------------------
  if (e.target.value.length == 0) {
    regex = new RegExp("[a-zA-Z]");
  } else {
    //--------------------------------------------
    // else only accept a-z/0-9/space/hyphen/apos
    //--------------------------------------------
    regex = new RegExp("[a-zA-Z0-9-' ]");
  }
  //------------------
  // obtain key value
  //------------------
  var key;
  // override to allow hyphen (173) as producing 1/2 symbol (189)
  if (e.key == "-") {
    key = "-";
  } else if (e.key == "'") {
    key = "'";
  } else {
      key = e.keyCode || e.which;
      key = String.fromCharCode(key);
  }
  //-----------------
  // check key value
  //-----------------
  if (!regex.test(key)) {
    return false;
  } else {
    return true;
  }
}
